import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";

/** Campo ora che applica il valore al blur o a Invio, non a ogni tasto. */
export default function TimeField({ label, value, onApply }) {
    const [local, setLocal] = useState(value);
    useEffect(() => setLocal(value), [value]);
    const apply = () => {
        if (local && local !== value) onApply(local);
    };
    return (
        <TextField
            label={label}
            type="time"
            size="small"
            value={local}
            onChange={e => setLocal(e.target.value)}
            onBlur={apply}
            onKeyDown={e => {
                if (e.key === "Enter") apply();
            }}
            InputLabelProps={{ shrink: true }}
            inputProps={{ step: 60 }}
        />
    );
}
